import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseResponse } from '../models/base.response';
import { DocoUser } from '../models/doco-user.model';

export const endpoints = {
  getAll: '/user/doco-users',
  getDetails: (id: string) => '/user/doco-users/' + id,
  add: '/user/add-doco-user',
  update: '/user/update-doco-user',
  delete: (id: string) => '/user/delete-doco-user/' + id
};


@Injectable()
export class DocoService {

  constructor(
    private http: HttpClient
  ) { }

  getAll(query: NzTableQueryParams): Observable<BaseResponse<DocoUser[]>> {
    const url = environment.apiBaseUrl + endpoints.getAll;
    return this.http.post<BaseResponse<DocoUser[]>>(url, query);
  }

  getDetails(id: string): Observable<BaseResponse<DocoUser>> {
    const url = environment.apiBaseUrl + endpoints.getDetails(id);
    return this.http.get<BaseResponse<DocoUser>>(url);
  }

  add(payload: DocoUser): Observable<BaseResponse<DocoUser>> {
    const url = environment.apiBaseUrl + endpoints.add;
    return this.http.post<BaseResponse<DocoUser>>(url, payload);
  }

  update(payload: DocoUser): Observable<BaseResponse<DocoUser>> {
    const url = environment.apiBaseUrl + endpoints.update;
    return this.http.post<BaseResponse<DocoUser>>(url, payload);
  }

  delete(id: string): Observable<BaseResponse<DocoUser>> {
    const url = environment.apiBaseUrl + endpoints.delete(id);
    return this.http.post<BaseResponse<DocoUser>>(url, {});
  }

}
